import { useEffect, useState } from "react";

/**
 * Estamos na largura de celular?
 *
 * O mesmo ponto de quebra do `layout.css`, onde a barra lateral vira rodapé.
 * Vale ser o mesmo número: o dia em que um componente decidir encolher numa
 * largura diferente da que muda a navegação, existe uma faixa de larguras em
 * que a tela está meio de um jeito e meio do outro.
 *
 * Isto é uma pergunta de JavaScript, e não de CSS, porque as duas respostas
 * desenham coisas diferentes e não a mesma coisa com outro tamanho: no
 * computador a barra mostra os catorze itens, e no celular mostra quatro mais
 * um menu. Esconder os outros dez com `display: none` deixaria dez botões no
 * documento que ninguém alcança, e um leitor de tela leria todos.
 */
const ESTREITO = "(max-width: 820px)";

export function useTelaEstreita(): boolean {
  const [estreita, definir] = useState(
    () => typeof window !== "undefined" && window.matchMedia?.(ESTREITO).matches === true,
  );

  useEffect(() => {
    const consulta = window.matchMedia?.(ESTREITO);
    if (!consulta) return;
    const aoMudar = (evento: MediaQueryListEvent): void => definir(evento.matches);
    definir(consulta.matches);
    consulta.addEventListener("change", aoMudar);
    return () => consulta.removeEventListener("change", aoMudar);
  }, []);

  return estreita;
}
